import { FC, SVGProps } from 'react';

const AIMessageIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#7A7A7A', size = 20, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 14.149 3.75317 16.122 5.00993 17.6696C5.16017 17.8546 5.17217 18.1188 5.0287 18.3091L3.96627 19.7184C3.56888 20.2456 3.94494 21 4.60508 21H12Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M10.0536 13.9784L9.95265 13.705C9.57178 12.6742 8.76027 11.8615 7.73094 11.4801L7.45801 11.3789L7.73094 11.2778C8.76027 10.8963 9.57178 10.0836 9.95265 9.05282L10.0536 8.77942L10.1546 9.05282C10.5355 10.0836 11.347 10.8963 12.3763 11.2778L12.6494 11.3789L12.3763 11.4801C11.347 11.8615 10.5355 12.6742 10.1546 13.705L10.0536 13.9784Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3652 15.2205C15.1936 14.6559 14.7523 14.214 14.1885 14.0421C14.7523 13.8702 15.1936 13.4283 15.3652 12.8636C15.5368 13.4283 15.978 13.8702 16.5418 14.0421C15.978 14.214 15.5368 14.6559 15.3652 15.2205Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AIMessageIcon;
